module.exports = __webpack_public_path__ + "img/sj.209f1a8d.svg";